import { lazy } from 'react';

const TrustedSecuritySectionLazy = lazy(() => import('../TrustedSecuritySection'));

export default TrustedSecuritySectionLazy;
